import config from '../utils/config'
import request from '../utils/request'

const {api} = config;
const {
    user,
    userDefault,
    usersEnableToken,
    userInfo,
} = api

/**
 * 查找当前用户
 */
export async function findUserDefault(params) {
    return request({url: userDefault, method: 'get', data: params,})
}
export async function findUserDefaultInfo(params) {
    return request({url: userInfo, method: 'get', data: params,})
}


/**
 * 编辑当前用户部分资料
 */
export async function updateUserPatchDefault(params) {
    return request({url: userDefault, method: 'patch', data: params,})
}

/**
 * 查找用户
 */
export async function findUser(params) {
    return request({url: user, method: 'get', data: params,})
}

/*token是否有效*/
export async function findUsersEnableToken(params) {
    return request({url: usersEnableToken, method: 'get', data: params,})
}




// WEBPACK FOOTER //
// ./src/services/user.js